import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PageTodo from './components/PageTodo';
import IconsPage from './components/IconsPage';
import PageStock from './components/PageStock';
import PageAuth from './components/PageAuth';
import RequireAuth from './components/RequireAuth';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/auth" element={<PageAuth />} />
        <Route path="/" element={<RequireAuth><PageTodo /></RequireAuth>} />
        <Route path="/icons" element={<IconsPage />} />
        <Route path="/:date/" element={<RequireAuth><PageTodo /></RequireAuth>} />
        <Route path="/tag/:tagId/" element={<RequireAuth><PageTodo /></RequireAuth>} />
        <Route path="/habit/:habitId/" element={<RequireAuth><PageTodo /></RequireAuth>} />
        <Route path="/stock/" element={<Navigate to="/stock/category/uncategorized/" replace />} />
        <Route path="/stock/:viewMode/:groupId/" element={<RequireAuth><PageStock /></RequireAuth>} />
        <Route path="/stock/:legacyGroupId/" element={<RequireAuth><PageStock /></RequireAuth>} />
      </Routes>
    </Router>
  );
}

export default App;
